import React from "react";

import Shutdown from "./Shutdown";

const Bottom = () => {
  return (
    <div className="start__bottom" data-test="bottom">
      <Shutdown />
    </div>
  );
};

export default Bottom;
